import { StaticLayerHandlerContribution } from "../../constants";

import { CanvasLayerHandlerContribution } from "./canvas2d-contribution";

export function bindLayerHandlerModules({bind: bind}) {
    bind(CanvasLayerHandlerContribution).toSelf(), bind(StaticLayerHandlerContribution).toService(CanvasLayerHandlerContribution);
}

export default bindLayerHandlerModules;
//# sourceMappingURL=modules.js.map
